import React from 'react';
import {SpecialistSearchResultDto} from "../../core/models/interfaces/specialists-search-result-dto.interface";
import {classNames} from "@utils/class-names";
import SpecialistProfileImage from "../../specialists/components/specialist-profile-image";
import {formatPhoneNumber} from "../../specialists/utils/format-phone-number";
import AppButton from "@common/components/app-button";
import {ReactComponent as PhoneIcon} from "@assets/icons/phone.svg";
import {ReactComponent as ZnanyLekarzLogoIcon} from "@assets/icons/znany-lekarz-logo.svg";
import NotificationService from "@common/services/notification.service";
import ClipboardHelper from "@utils/clipboard-helper";

interface PublicSpecialistCardProps {
    specialist: SpecialistSearchResultDto;
    className?: string;
}

const PublicSpecialistCard: React.FC<PublicSpecialistCardProps> = ({specialist, className = ''}) => {
    const handlePhoneClick = async (): Promise<void> => {
        const raw = specialist.phoneNumber || "";
        const phoneForTel = raw.replace(/[^\d+]/g, "");
        const isMobileDevice = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent || "");

        if (isMobileDevice) {
            window.location.href = `tel:${phoneForTel}`;
            return;
        }

        await ClipboardHelper.copyText(
            phoneForTel,
            () => NotificationService.success("Numer telefonu skopiowany do schowka"),
            () => NotificationService.error("Nie udało się skopiować numeru")
        );
    };

    const handleRedirectToDoctor = async (): Promise<void> => {
        window.open(specialist.znanyLekarzUrl ?? "https://znanylekarz.pl", '_blank', 'noreferrer');
    };

    return (
        <div
            className={classNames(
                "lg:w-[576px] bg-white border p-4 rounded-[31px] flex flex-col gap-4 border-outline",
                className
            )}
        >
            <div className="flex gap-6">
                <div className="shrink-0">
                    <SpecialistProfileImage
                        className="w-[98px] h-[98px]"
                        classNameImg="!rounded-3xl"
                        specialistId={specialist.id}
                        specialistName={specialist.fullName}/>
                </div>
                <div className="space-y-3">
                    <div className="font-semibold text-on-surface truncate text-lg leading-[22px]">
                        {specialist.fullName}
                    </div>
                    <div className="text-base text-on-surface/70 mt-1 truncate leading-[20px]">
                        {specialist.specialization}
                    </div>
                    {/*{Boolean((specialist as any)?.rating || (specialist as any)?.reviewsCount) && (*/}
                    {/*    <div className="mt-2 flex items-center gap-2 text-sm text-on-surface/70">*/}
                    {/*        <span className="inline-block align-middle">{(specialist as any)?.rating ?? ''}</span>*/}
                    {/*        {(specialist as any)?.reviewsCount && (*/}
                    {/*            <span className="inline-block align-middle">{(specialist as any)?.reviewsCount} opinii</span>*/}
                    {/*        )}*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </div>

            <div className="flex flex-1 min-w-0 items-center flex-wrap gap-2">
                <AppButton
                    className="bg-primary text-on-primary font-semibold text-sm rounded-full !py-0 h-12 !px-5"
                    classNameContentWrapper="gap-2"
                    onClick={handlePhoneClick}
                >
                    <div className="flex gap-2 items-center">
                        <PhoneIcon className="w-[14px] h-[20px]"/>
                        <span className="font-semibold text-base">{formatPhoneNumber(specialist.phoneNumber)}</span>
                    </div>
                </AppButton>

                <AppButton
                    className="bg-primary text-on-primary font-semibold text-sm rounded-full !py-0 h-12 !px-5 whitespace-nowrap"
                    onClick={handleRedirectToDoctor}
                    label=""
                >
                    <div className="flex gap-2 items-center">
                        <ZnanyLekarzLogoIcon className="w-[20px] h-[20px]"/>
                        <span className="font-semibold text-base">Umów przez ZnanyLekarz</span>
                    </div>
                </AppButton>
            </div>
        </div>
    );
};

export default PublicSpecialistCard;



